import Navbar from "../components/Navbar";
import ReferencesCard from "../components/ReferencesCard";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function References() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="bg-[#060813] min-h-screen text-white overflow-x-hidden">
      <Navbar />

      {/* --- HEADER SECTION --- */}
      <section className="relative pt-40 pb-20 px-6 overflow-hidden">
        {/* Arka Plan Glow Efektleri - HomePage ile uyumlu */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10">
          <div className="absolute top-[-20%] left-[-10%] w-[40%] h-[40%] bg-[#ff471d]/10 blur-[120px] rounded-full" />
          <div className="absolute bottom-0 right-[-10%] w-[30%] h-[40%] bg-purple-900/10 blur-[120px] rounded-full" />
        </div>

        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-md">
            <Sparkles size={16} className="text-[#ff471d]" />
            <span className="text-xs font-bold tracking-[0.2em] text-gray-400 uppercase">
              {t("portfolio")}
            </span>
          </div>

          <h1 className="text-5xl md:text-8xl font-black tracking-tighter leading-none mb-8 italic">
            {t("references_title")}
          </h1>

          <p className="max-w-2xl mx-auto text-gray-400 text-lg md:text-xl leading-relaxed">
            {t("references_desc") ||
              "Markanız için hayata geçirdiğimiz dijital dönüşüm hikayeleri ve başarı odaklı projelerimiz."}
          </p>
        </div>
      </section>

      {/* --- CONTENT SECTION --- */}
      <section className="pb-32 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Kartların etrafına hafif bir cam efekti veren kapsayıcı */}
          <div className="bg-white/[0.02] border border-white/5 rounded-[3rem] p-8 md:p-16 backdrop-blur-sm transition-all hover:border-white/10">
            <ReferencesCard limit={12} />
          </div>
        </div>
      </section>

      {/* --- CTA SECTION (Kapanış) --- */}
      <section className="py-24 px-6">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-[#060813] to-[#1e2a8a] rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden group">
          {" "}
          {/* İçerideki süs halkaları */}
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-white/50 blur-3xl rounded-full " />
          <div className="relative z-10 ">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-8 tracking-tighter uppercase leading-none">
              {t("Sıradaki Proje Sizin Olsun") ||
                "Sıradaki Başarı Hikayesi Sizin Olsun"}
            </h2>
            <button
              onClick={() =>
                navigate("/", { state: { scrollTo: "home-contact" } })
              }
              className="px-10 py-5 bg-white text-black font-black rounded-full hover:scale-105 transition-all flex items-center gap-3 mx-auto shadow-2xl"
            >
              {t("Başlayalım")} <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
